<template>
  <el-container direction="vertical" id="quoteMainSaveSuccess">
    <div class="space-between topUnit">
      <div class="smallPicture"></div>
      <div style="text-align: left;">
        <div class="header-col-p-big">报价单已生成！</div>
        <div class="header-col-p-small">报价单有效期为30天，本报价有效期至{{overTime}}.</div>
      </div>
    </div>
    <div class="space-between bottomUnit">
      <a :href = "pdfUrl" style="display: inline">
        <el-button class="header-row-col-button-success">下载报价书</el-button>
      </a>
      <el-button @click="quoteMainCheck" class="header-row-col-button-failure">查看我的报价书</el-button>
    </div>
  </el-container>
</template>

<script>
    export default {
        name: "quoteMainSaveSuccess",
      data(){
          return {
            overTime : '',
            pdfUrl : '',
          }
      },
      methods:{
        quoteMainCheck(){
          this.$router.push({ name: 'quotationManagement'});
        }
      },
      mounted() {
        let params = sessionStorage.getItem('params');

        if (this.$$.isValidObj(params) && params != 'undefined'){
          params = JSON.parse(params);
          this.overTime = params.overTime.split(" ")[0];
          this.pdfUrl = params.pdfUrl;
        }
      }
    }
</script>

<style scoped>

  .header-content {
    text-align: center;
    background-color: #ffffff !important;
  }

  .topUnit{
    margin: 0 auto;
  }

  #quoteMainSaveSuccess{
    padding-top: 144px;
  }

  .smallPicture {
    width: 72px;
    height: 72px;
    background: url("../../../../static/images/public/quoteMainSaveSuccess-01.png") no-repeat center center /100% 100%;
    margin: 10px 23px 0 0;
  }

  .header-col-p-big{
    font-size: 40px;
    font-weight: bold;
    color: #333333;
  }

  .header-col-p-small{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }

  .bottomUnit{
    padding-top: 55px;
    margin: 0 auto;
  }

  .header-row-col-button-success{
    width: 144px;
    height: 40px;
    background-color: #FF7052;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0 15px;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .header-row-col-button-failure{
    width: 144px;
    height: 40px;
    background-color: #528BFF !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0 15px;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .el-button{
    padding: 12px 0;
  }

  .divLayout{
    padding-bottom: 346px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/quoteMainSaveSuccess.vue